module.exports = __webpack_public_path__ + "static/media/icon-baby-blue.fb50449f.svg";